export const GUIDE_STEP_COUNT = 3;

export const GUIDE_MODAL_TITLE_ID = 'leadsGuide.title' as const;

export const GUIDE_STEP_TITLE_IDS = [
  'leadsGuide.step1.title',
  'leadsGuide.step2.title',
  'leadsGuide.step3.title',
] as const;

export const GUIDE_TAB_LABEL_IDS = [
  'leadsGuide.tabs.howItWorks',
  'leadsGuide.tabs.profile',
  'leadsGuide.tabs.leads',
] as const;
